'use client';

import { c as _c } from "react/compiler-runtime";
import '../scripts/wdyr';
import React, { ReactNode, useContext, useEffect } from 'react';
import { Provider, ErrorBoundary } from '@rollbar/react';
import { ToastContainer } from 'react-toastify';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Smartlook from 'smartlook-client';
import { observer } from 'mobx-react';
import { RootStoreContext, rootStore } from '@stores/rootStore';
import { Tooltip } from 'react-tooltip';
import { rollbarInstance } from '@services/rollbar';
const queryClient = new QueryClient();
function ClientLayout(t0) {
  const $ = _c(8);
  const {
    children
  } = t0;
  const {
    userStore
  } = useContext(RootStoreContext);
  let t1;
  if ($[0] !== userStore) {
    t1 = () => {
      if (process.env.NEXT_PUBLIC_RUN_ENV === "production" && userStore.isLoggedIn && !userStore.isLF) {
        Smartlook.init("20759b1a49856be27223b69ff0654c4134d65ca1", {
          region: "us"
        });
      }
    };
    $[0] = userStore;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Tooltip className={"\n                hidden\n                lg:block\n              "} id="main-tooltip" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Tooltip className="max-w-sm break-words whitespace-pre-line" openEvents={{
      click: true,
      mouseover: true
    }} id="mobile-enabled-tooltip" />;
    t5 = <ToastContainer position="top-center" className="z-50" autoClose={5000} hideProgressBar={false} newestOnTop={true} closeOnClick={true} rtl={false} pauseOnFocusLoss={true} draggable={true} pauseOnHover={true} />;
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] !== children) {
    t6 = <Provider instance={rollbarInstance}><ErrorBoundary><RootStoreContext.Provider value={rootStore}><QueryClientProvider client={queryClient}>{children}{t3}{t4}{t5}</QueryClientProvider></RootStoreContext.Provider></ErrorBoundary></Provider>;
    $[6] = children;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6;
}
export default observer(ClientLayout);